import {
  Button, FormControl,
  Grid,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import clsx from 'clsx';
import { range } from "lodash-es";
import React, { useEffect, useState } from "react";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import { useHistory } from "react-router-dom";
import { StyledTableRow } from "components/common/Table";
import AppointmentService from "services/AppointmentService";
import { DatePicker } from "@material-ui/pickers";
import DatetimeService from "services/DatetimeService";
import { format } from "date-fns";
import { VISA_TYPE_NAME } from "libs/configs/constant";

const useStyles = makeStyles((theme) => ({
  paper: {
    // display: "flex",
    // flexDirection: "column",
    // flexWrap: "wrap",
    // padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpData: {
    marginTop: 20
  },
  warpAppHeader: {
    marginTop: 15
  },
  month: {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#101A5F',
  },
  warpButton: {
    textAlign: 'right'
  },
  buttonSave: {
    marginLeft: 5,
    // width: 120
  },
  monthView: {
    overflowX: 'auto',
    marginTop: 30
  },
  weekRow: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 1000,
  },
  dayGroup: {
    width: '14%',
    display: 'block'
  },
  dayGroupHead: {
    width: '14%',
    padding: '10px 5px',
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  day: {
    textAlign: 'center'
  },
  dayRow: {
    height: "125px", backgroundColor: "white", minWidth: "130px", width: "100%", border: "1px solid gainsboro", cursor: "pointer", padding: "5px", position: "relative", display: "flex", flexDirection: "column"
  },
  dayDisable: {
    backgroundColor: '#eeeeee'
  },
  dateNum: { fontWeight: "bold", borderRadius: "50%", width: "22px", height: "21px", textAlign: "center", fontSize: "0.9rem", color: "#2b2b2b", zIndex: "1" },
  isCurr: { border: "1px solid #40B8D4 !important", backgroundColor: "#40B8D4 !important", color: "white !important" },
  detail_row: { display: "flex", alignItems: "center", justifyContent: "center", height: "100%", marginTop: "-20px" },
  detailDay: { width: "35px", height: "30px", margin: "0px 5px", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "500" },
  pendingCount: { backgroundColor: "#F8BD2C", color: "white" },
  completedCount: { backgroundColor: "#2DCE98", color: "white" },
  warpDesc: { display: "flex", alignItems: "center", marginTop: "15px" },
  warpDescDetail: { display: "flex", alignItems: "center", marginRight: "15px" },
  tableHead: {
    color: "black", backgroundColor: "white", fontWeight: "500",
    width: "1%", whiteSpace: "nowrap"
  },

  tableCell: {
    backgroundColor: 'white',
    borderBottom: "1px solid rgba(224, 224, 224, 0.5)",
    width: "1%", whiteSpace: "nowrap"
  },
  p0: {
    padding: 0
  }
}));


function AppointmentDay(props) {
  const classes = useStyles();
  const date = new Date().getDate();



  return (
    <React.Fragment>
      <div className={clsx(classes.dayRow, {
        [classes.dayDisable]: props.disable,
      })}>
        <div className={clsx(classes.dateNum, {
          [classes.isCurr]: props.day === date,
        })}>
          {props.day}
        </div>


        {
          +props.pendingCount > 0 &&

          <div className={classes.detail_row}>
            <div className={clsx(classes.detailDay, classes.pendingCount)}>
              {+props.pendingCount}
            </div>
          </div>
        }

        {
          +props.completedCount > 0 &&
          <div className={classes.detail_row}>
            <div className={clsx(classes.detailDay, classes.completedCount)}>
              {+props.completedCount}
            </div>
          </div>
        }


        {/* <div className={classes.detail_row}>
          <div className={clsx(classes.detailDay, {
            [classes.pendingCount]: +props.pendingCount > 0,
            [classes.completedCount]: +props.completedCount > 0,
          })}>

          </div>
        </div> */}
      </div>
    </React.Fragment >
  )
}

function createData(date, docNo, firstName, lastName, email, tel, visaType, status, staff) {

  return { date, docNo, firstName, lastName, email, tel, visaType, status, staff };
}

function AppointmentPage() {
  const classes = useStyles();
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const history = useHistory();
  const [monthView, setMonthView] = useState(true);
  const [appDate, setAppDate] = useState(new Date());
  const [dayDate, setDayDate] = useState(new Date());
  const date = DatetimeService.getFirstAndLastDayOfMonth(new Date(appDate));
  const firstDate = date.firstDate;
  const indexFirstDate = firstDate.getDay();

  const [appointments, setAppointments] = useState([]);


  useEffect(async () => {
    await getAppointment();

  }, [appDate])




  const getAppointment = async () => {
    const flDate = DatetimeService.getFirstAndLastDayOfMonth(new Date(appDate));


    const body = {
      startTime: format(flDate.firstDate, "yyyy-MM-dd"),
      endTime: format(flDate.lastDate, "yyyy-MM-dd")
    };

    const res = await AppointmentService.getAppointments(body);
    if (res.status) {
      setAppointments(res.results.map(x => ({ ...x, date: new Date(x.stampDate) })))
    }

  }

  const rows = [
    createData('2022-01-01', 'T0001', 'Theerawat', 'Burawat', 'theerawat@mail.com', '081-111-1111', 'Smart T', 'Completed', 'Anupong Siripun'),
    createData('2022-01-02', 'T0002', 'Sirinapa', 'Kongdee', 'Sirinapa@mail.com', '082-222-2222', 'Smart E', 'Rejected', 'Anupong Siripun'),
    createData('2022-01-02', 'T0003', 'Pratompong', 'Pratop', 'Pratompong@mail.com', '083-333-3333', 'Smart O', 'Completed', 'Anupong Siripun'),
    createData('2022-01-03', 'T0004', 'Aumsin', 'Pinyanee', 'Aumsin@mail.com', '084-444-4444', 'Smart T', 'Completed', 'Anupong Siripun'),
    createData('2022-01-04', 'T0005', 'Pracharapong', 'Sirinukol', 'Pracharapong@mail.com', '085-555-5555', 'Smart S', 'Completed', 'Anupong Siripun'),
    createData('2022-01-04', 'T0006', 'Anusorn', 'Tongdee', 'Anusorn@mail.com', '086-666-6666', 'Smart T', 'Rejected', 'Anupong Siripun'),
    createData('2022-01-05', 'T0007', 'Jitta', 'Waririn', 'Jitta@mail.com', '087-777-7777', 'Smart T', 'Completed', 'Anupong Siripun'),
  ];

  return (
    <div className={classes.paper}>
      <AdminTitle title="Smart VISA" subTitle="Issuance Appointment" />
      <div className={classes.warpData}>
        <div className={classes.warpAppHeader}>
          <Grid container spacing={3}>

            <Grid item xs={6}>
              {
                monthView &&
                <>
                  <div className={classes.month}>
                    <DatePicker
                      style={{ width: 200, marginRight: 15 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="MM-YYYY"
                      label="Appointment Date"
                      views={["year", "month"]}
                      name={`appointmentDate`}
                      value={appDate}
                      onChange={async (e) => {
                        console.log(e);
                        setAppDate(e)

                      }}
                    />
                  </div>
                </>
              }

              {
                !monthView &&
                <>
                  <div className={classes.month}>
                    <DatePicker
                      style={{ width: 200, marginRight: 15 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Appointment Date"
                      views={["year", "month", "date"]}
                      name={`appointmentDateDay`}
                      value={dayDate}
                      onChange={async (e) => {
                        console.log(e);
                        setDayDate(e)
                      }}
                    />
                  </div>
                  {/* <div className={classes.month}>
                    <DatePicker
                      style={{ width: 200, marginRight: 15 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Appointment Date"
                      views={["year", "month", "date"]}
                      name={`appointmentDateDay`}
                      value={appDate}
                      onChange={async (e) => {
                        setAppDate(e)
                        console.log(e);
                      }}
                    />
                  </div> */}
                </>
              }
            </Grid>
            <Grid item xs={6} className={classes.warpButton}>
              <Button variant={monthView ? 'contained' : 'outlined'} size="small" color="primary" className={classes.buttonSave} onClick={() => setMonthView(true)}>
                Month
              </Button>

              <Button variant={monthView ? 'outlined' : 'contained'} size="small" color="primary" className={classes.buttonSave} onClick={() => setMonthView(false)}>
                Day
              </Button>
            </Grid>
          </Grid>
        </div>

        {
          monthView &&
          <>
            <div className={classes.monthView}>

              <div className={classes.weekRow}>
                {
                  days.map(d => {
                    return (
                      <div key={d} className={classes.dayGroupHead}>
                        {d}
                      </div>
                    )
                  })
                }

              </div>

              <div className={classes.weekRow}>

                {
                  range(0, indexFirstDate).map((r, index) => {
                    return (
                      <div className={classes.dayGroup} key={r}>
                        <AppointmentDay disable={true} />
                      </div>
                    )
                  })
                }
                {
                  range(1, 31).map((r, index) => {
                    return (
                      <div className={classes.dayGroup} key={r} onClick={() => {
                        // history.push(`/admin/smart-visa/appointment/1234`)
                        const _date = new Date(appDate);
                        _date.setDate(r);

                        setAppDate(_date)
                        setDayDate(_date)
                        setMonthView(false)
                      }}>
                        <AppointmentDay
                          disable={false}
                          day={r}
                          pendingCount={appointments.filter(x => x.date?.getDate() === r && x.stampStatus === 'P').length}
                          completedCount={appointments.filter(x => x.date?.getDate() === r && x.stampStatus === 'C').length}

                        />
                      </div>
                    )
                  })
                }

              </div>

              <div className={classes.warpDesc}>
                <div className={classes.warpDescDetail}>
                  <FiberManualRecordIcon style={{ color: '#2DCE98' }} />
                  <span>
                    {/* Confirm the appointment */}
                    Completed
                  </span>
                </div>
                <div className={classes.warpDescDetail}>
                  <FiberManualRecordIcon style={{ color: '#FEB969' }} />
                  <span>
                    {/* An appointment date was not specified. */}
                    Pending
                  </span>
                </div>
              </div>
            </div >

          </>
        }

        {
          !monthView &&
          <>


            <TableContainer component={Paper} style={{ borderRadius: 0, maxHeight: '73vh', marginTop: 30 }}>
              <Table stickyHeader className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                  <StyledTableRow>
                    <TableCell className={classes.tableHead}> Appointment Date</TableCell>
                    <TableCell className={classes.tableHead} >Doc No.</TableCell>
                    <TableCell className={classes.tableHead} >First Name</TableCell>
                    <TableCell className={classes.tableHead} >Last Name</TableCell>
                    <TableCell className={classes.tableHead} >Visa Type</TableCell>
                    <TableCell className={classes.tableHead} >Status</TableCell>
                    <TableCell className={classes.tableHead} >Staff</TableCell>
                    <TableCell className={classes.tableHead} align={'center'}>Detail</TableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {appointments.filter(x => x.date.getDate() === appDate.getDate()).map((row, index) => (
                    <StyledTableRow key={row?.stampAppointmentId}>
                      <TableCell className={classes.tableCell} component="th" scope="row">
                        {format(new Date(row.date), "yyyy-MM-dd")}
                      </TableCell>
                      <TableCell className={classes.tableCell}>{row?.docNo}</TableCell>
                      <TableCell className={classes.tableCell} >{row?.personalFirstName}</TableCell>
                      <TableCell className={classes.tableCell} >{row?.personalLastName}</TableCell>
                      <TableCell className={classes.tableCell} >{VISA_TYPE_NAME[row?.visaType]}</TableCell>
                      <TableCell className={classes.tableCell} >{row?.stampStatus === 'P' ? 'Pending' : 'Completed'}</TableCell>
                      <TableCell className={classes.tableCell} >{row?.empAssignedFirstName} {row?.empAssignedLastName}</TableCell>
                      <TableCell className={classes.tableCell} align={'center'}>
                        <Button variant='outlined' size="small" color="primary" onClick={() => {
                          history.push(`/admin/smart-visa/appointment/${row.draftId}`)
                        }}>
                          View
                        </Button>
                      </TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          </>
        }
      </div >

    </div >
  );
}

export default AppointmentPage;
